import { render } from "./Remarks.vue?vue&type=template&id=6b15ffda&scoped=true"
import script from "./Remarks.vue?vue&type=script&lang=js"
export * from "./Remarks.vue?vue&type=script&lang=js"

import "./Remarks.vue?vue&type=style&index=0&id=6b15ffda&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b15ffda"]])

export default __exports__